import PropTypes from 'prop-types';
import NumberFlow from '@number-flow/react';
import classes from './labelValueDisplay.module.css';

const NumberFlowDisplay = (props) => {
  const {
    value,
    suffix,
    showValueAnimation = true,
  } = props;

  const valueElement = (showValueAnimation)
    ? <NumberFlow value={value} transformTiming={{
      duration: 1000,
      easing: 'linear(0, 0.0033 0.8%, 0.0263 2.39%, 0.0896 4.77%, 0.4676 15.12%, 0.5688, 0.6553, 0.7274, 0.7862, 0.8336 31.04%, 0.8793, 0.9132 38.99%, 0.9421 43.77%, 0.9642 49.34%, 0.9796 55.71%, 0.9893 62.87%, 0.9952 71.62%, 0.9983 82.76%, 0.9996 99.47%)',
    }} />
    : value;

  return (
    <div className={classes.warpper}>
      <span className={classes.value}>{valueElement}</span>
      {suffix && <span className={classes.suffix}>{suffix}</span>}
    </div>
  );
};

NumberFlowDisplay.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  prefix: PropTypes.any,
  suffix: PropTypes.any,
  showValueAnimation: PropTypes.bool,
};

export default NumberFlowDisplay;
